import React from 'react';
import { useLanguage } from './LanguageContext';
export const BeforeAfter = () => {
  const {
    t
  } = useLanguage();
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-gold-light py-16 md:py-20" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-10 md:mb-12 px-2" data-id="element-16">
          <span className="text-brand-gold font-montserrat font-medium text-[12px] tracking-[4px] uppercase block mb-4" data-id="element-17">
            {t('ba.label')}
          </span>
          <h2 className="font-montserrat font-extrabold text-[26px] md:text-[42px] text-brand-navy mb-4 leading-[1.3] md:leading-tight" data-id="element-18">
            {t('ba.title')}
          </h2>
          <p className="font-inter text-[15px] md:text-[18px] text-[#4A5568] max-w-[600px] mx-auto" data-id="element-19">
            {t('ba.sub')}
          </p>
        </div>

        <div className="max-w-[900px] mx-auto" data-id="element-20">
          {/* Image Container */}
          <div className="overflow-hidden shadow-[0_20px_60px_rgba(27,43,94,0.18)] bg-white" style={{
          borderRadius: '20px 20px 0 0'
        }} data-id="element-21">
            <img src="https://cdn.magicpatterns.com/uploads/9541jPXTyAvKQexbMjyHGK/Antes_y_despues_2_girls.png" alt="Before and After cleaning by TwoGirls MopCo" className="block w-full h-auto object-cover" data-id="element-22" />
          </div>

          {/* Stats Bar — single row on mobile, equal columns */}
          <div className="bg-white py-5 px-3 md:p-7 md:px-10 grid grid-cols-3 md:flex md:flex-row md:justify-between items-center gap-2 md:gap-6 shadow-lg" style={{
          borderRadius: '0 0 20px 20px',
          borderTop: '3px solid #C9A84C'
        }} data-id="element-23">
            <div className="flex flex-col md:flex-row items-center md:items-center gap-1 md:gap-3 text-center md:text-left" data-id="element-24">
              <span className="font-montserrat font-extrabold text-[28px] md:text-[32px] text-brand-navy leading-none" data-id="element-25">
                100%
              </span>
              <span className="font-inter text-[11px] md:text-[13px] text-[#4A5568] md:max-w-[120px] leading-tight" data-id="element-26">
                {t('ba.stat1')}
              </span>
            </div>
            <div className="hidden md:block w-[1px] h-10 bg-[#F0DCE6]" data-id="element-27" />
            <div className="flex flex-col md:flex-row items-center md:items-center gap-1 md:gap-3 text-center md:text-left border-x md:border-0 border-[#F0DCE6]" data-id="element-28">
              <span className="font-montserrat font-extrabold text-[28px] md:text-[32px] text-brand-gold leading-none" data-id="element-29">
                24h
              </span>
              <span className="font-inter text-[11px] md:text-[13px] text-[#4A5568] md:max-w-[120px] leading-tight" data-id="element-30">
                {t('ba.stat2')}
              </span>
            </div>
            <div className="hidden md:block w-[1px] h-10 bg-[#F0DCE6]" data-id="element-31" />
            <div className="flex flex-col md:flex-row items-center md:items-center gap-1 md:gap-3 text-center md:text-left" data-id="element-32">
              <span className="font-montserrat font-extrabold text-[28px] md:text-[32px] text-brand-navy leading-none" data-id="element-33">
                5★
              </span>
              <span className="font-inter text-[11px] md:text-[13px] text-[#4A5568] md:max-w-[120px] leading-tight" data-id="element-34">
                {t('ba.stat3')}
              </span>
            </div>
          </div>
        </div>

        <div className="text-center mt-8 md:mt-9 px-4 md:px-0" data-id="element-35">
          <button onClick={() => scrollTo('contact')} className="bg-brand-gold hover:bg-white text-brand-navy hover:text-brand-navy font-montserrat font-extrabold w-full sm:w-auto h-[48px] md:h-[56px] px-6 md:px-11 rounded-[28px] inline-flex items-center justify-center transition-all duration-300 hover:-translate-y-0.5 text-[14px] md:text-base" style={{
          boxShadow: '0 8px 25px rgba(201,168,76,0.40)'
        }} data-id="element-36">
            {t('ba.cta')}
          </button>
        </div>
      </div>
    </section>;
};